import { Component } from '@theme/component';

const STORAGE_PREFIX = 'habelle:favorites:';
const TOGGLE_EVENT = 'habelle:favorite-toggled';

/**
 * @param {string} customerId
 * @returns {string[]}
 */
function getFavorites(customerId) {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_PREFIX + customerId) || '[]');
  } catch {
    return [];
  }
}

/**
 * @extends {Component<{}>}
 */
class FavoritesList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.customerId = this.dataset.customerId || '';
    this.sectionId = this.dataset.sectionId || '';
    this.emptyText = this.dataset.emptyText || '';
    this.limit = parseInt(this.dataset.limit, 10) || 0;
    this.load();
    this.onToggle = () => this.load();
    document.addEventListener(TOGGLE_EVENT, this.onToggle);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(TOGGLE_EVENT, this.onToggle);
  }

  async load() {
    const track = this.querySelector('.favorites-list__track');
    const emptyEl = this.querySelector('.favorites-list__empty');
    if (!track || !this.sectionId) return;

    let handles = this.customerId ? getFavorites(this.customerId) : [];
    if (this.limit > 0) handles = handles.slice(0, this.limit);

    if (!handles.length) {
      track.innerHTML = '';
      if (emptyEl) {
        emptyEl.textContent = this.emptyText;
        emptyEl.hidden = false;
      }
      return;
    }

    const cardFrom = (doc) => {
      const template = doc.getElementById('favorites-card-source-' + this.sectionId);
      if (!template) return null;
      const holder = document.createElement('div');
      holder.innerHTML = template.innerHTML;
      return holder.firstElementChild;
    };

    const results = await Promise.all(
      handles.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${encodeURIComponent(this.sectionId)}`, {
            headers: { 'X-Requested-With': 'fetch' },
          });
          if (!response.ok) return null;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return cardFrom(doc);
        } catch {
          return null;
        }
      })
    );

    const cards = results.filter(Boolean);

    if (!cards.length) {
      track.innerHTML = '';
      if (emptyEl) {
        emptyEl.textContent = this.emptyText;
        emptyEl.hidden = false;
      }
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    track.replaceChildren(...cards);
  }
}

if (!customElements.get('favorites-list')) {
  customElements.define('favorites-list', FavoritesList);
}
